// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__2RE8S","col":"styles_col__2u1nc"};